/**
 * CSRF攻撃対策ユーティリティ
 * same_site="lax"に変更したことによるセキュリティリスクを軽減
 */

// CSRFトークンを生成
export function generateCSRFToken(): string {
  const array = new Uint8Array(32);
  crypto.getRandomValues(array);
  return Array.from(array, byte => byte.toString(16).padStart(2, '0')).join('');
}

// CSRFトークンを取得（セッションストレージから）
export function getCSRFToken(): string {
  if (typeof window === 'undefined') return '';

  let token = sessionStorage.getItem('csrf_token');
  if (!token) {
    token = generateCSRFToken();
    sessionStorage.setItem('csrf_token', token);
  }
  return token;
}

// APIリクエストにCSRFトークンを含める
export function addCSRFHeaders(headers: Record<string, string> = {}): Record<string, string> {
  const token = getCSRFToken();
  return {
    ...headers,
    'X-CSRF-Token': token,
    'X-Requested-With': 'XMLHttpRequest', // AJAX リクエストの識別
  };
}

// フェッチリクエストでCSRF保護を追加
export async function protectedFetch(url: string, options: RequestInit = {}): Promise<Response> {
  const headers = addCSRFHeaders(options.headers as Record<string, string>);

  return fetch(url, {
    ...options,
    headers,
    credentials: 'include', // セッションCookieを含める
  });
}

// セキュリティ警告をログ出力
export function logSecurityWarning() {
  if (process.env.NODE_ENV === 'development') {
    console.warn(
      '🛡️ SECURITY NOTE: SameSite=lax is used for OAuth compatibility. ' +
      'Additional CSRF protection is implemented to mitigate risks.'
    );
  }
}
